<template>

    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="28px" height="28px"
         viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">

        <g>
            <g>
                <g>
                    <path class="st0 test" d="M25.9,7.7h-9c1.3-0.7,2.2-2,2.2-3.6C19.1,1.8,17.2,0,15,0c-2.2,0-4.1,1.8-4.1,4.1c0,1.6,0.9,2.9,2.2,3.6h-9
                        C2.9,7.7,2,8.6,2,9.8c0,0.9,0.6,1.7,1.4,2l6.4,2.4c0.1,0,0.2,0.1,0.1,0.2L8.3,27.7c-0.1,0.6,0.1,1.2,0.5,1.6
                        c0.4,0.4,1,0.7,1.6,0.7c0.9,0,1.8-0.6,2-1.5l2.3-7.4c0,0,0-0.2,0.2-0.2c0.2,0,0.2,0.1,0.2,0.2l2.3,7.4c0.3,0.9,1.1,1.5,2.1,1.5
                        c0.6,0,1.2-0.3,1.6-0.7c0.4-0.4,0.6-1,0.5-1.7l-1.6-13.2c0-0.1,0.1-0.2,0.1-0.2l6.4-2.4c0.8-0.3,1.4-1.1,1.4-2
                        C28,8.6,27.1,7.7,25.9,7.7z M15,1.9c1.2,0,2.1,1,2.1,2.1c0,1.2-1,2.1-2.1,2.1c-1.2,0-2.1-1-2.1-2.1C12.9,2.9,13.8,1.9,15,1.9z
                         M26,10l-6.4,2.4c-0.9,0.3-1.5,1.2-1.4,2.2l1.6,13.2c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.2L17,20.6
                        c-0.3-0.9-1.1-1.5-2-1.5c-1,0-1.8,0.6-2,1.5l-2.3,7.4c0,0.1-0.1,0.2-0.3,0.2c-0.1,0-0.1,0-0.2-0.1c0,0-0.1-0.1-0.1-0.1l1.7-13.3
                        c0.1-1-0.5-1.9-1.4-2.2L4,10C4,10,3.9,9.9,3.9,9.8c0-0.1,0.1-0.2,0.2-0.2h21.8c0.1,0,0.2,0.1,0.2,0.2C26.1,9.9,26,10,26,10z"/>
                </g>
            </g>
        </g>
    </svg>

</template>

<script>
    export default {
        name: "AL_svg"
    }
</script>




// WEBPACK FOOTER //
// src/common/components/svg/chapter/AL_svg.vue